// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessOilBarrel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5 2a.5.5 0 0 1 .5.5V3h2.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H18v3h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H18v5h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H18v3h.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H6v-3h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H6v-5h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H6V5h-.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H13v-.5a.5.5 0 0 1 .5-.5zM8 5v15h8V5zm4 10.158c.981 0 1.5-.682 1.5-1.2 0-.478-.288-1.336-.835-2.399-.185-.359-.383-.712-.58-1.043a.1.1 0 0 0-.17 0c-.196.331-.395.684-.58 1.043-.547 1.063-.835 1.92-.835 2.399 0 .518.519 1.2 1.5 1.2zm-3-1.2c0-1.743 1.8-4.566 2.612-5.75a.467.467 0 0 1 .776 0C13.2 9.392 15 12.215 15 13.958c0 1.49-1.343 2.7-3 2.7s-3-1.21-3-2.7z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBusinessOilBarrel;
